<div class="management-toolbar" [class.trace-mode]="isTraceMode">
  @if (isRunning) {
    <div class="running-indicator">
      <span class="running-label">Running canvas...</span>
    </div>
  } @else if (isTraceMode) {
    <span class="trace-mode-label">Trace mode</span>
    <ddc-command-invoker
      [args]="argsFor(exitTraceModeCommand)"
      [command]="exitTraceModeCommand"
      (executed)="onCommandExecuted()"
    />
  }
  @for (cmd of commands; track cmd.id) {
    <ddc-command-invoker [args]="argsFor(cmd)" [command]="cmd" (executed)="onCommandExecuted()" />
  }
</div>
